import { Stack as MuiStack, type StackProps as MuiStackProps } from '@mui/material';
import { forwardRef } from 'react';

export type StackProps = MuiStackProps;

export const Stack = forwardRef<HTMLDivElement, StackProps>(function Stack(props, ref) {
  return <MuiStack ref={ref} {...props} />;
});
